<template>
	<div>
		<div class="flex">
			<div class="lg:w-1/2 flex"></div>
			<div class="lg:w-1/2 flex justify-end">
				<!-- <ButtonBlack>
            <router-link :to="'/admin/' + section" class="text-white no-underline">
              <div class="flex items-center">
                <img src="@/assets/img/nuevo-mas.svg" alt="Nuevo">
                <span>{{$t("new")}}</span>
              </div>
            </router-link>
          </ButtonBlack> -->
				<ButtonBlack>
					<router-link
						:to="'/admin/listado/delegaciones'"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<span>{{ $t('Delegations') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
				<ButtonBlack>
					<router-link
						:to="'/admin/listado/provincias'"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<span>{{ $t('states') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
			</div>
		</div>
		<ListTable
			:itemsTitles="itemsTitles"
			:items="organizations"
			:itemsTable="itemsTable"
			:section="section"
		/>
	</div>
</template>

<script>
import ListTable from '@/components/ListTable'
import { fetchOrganizationsList } from '@/apollo/organizations'

export default {
	apollo: {
		organizations: fetchOrganizationsList()
	},
	data() {
		return {
			section: 'organizaciones',
			itemsTable: 'organizations',
			itemsTitles: ['Id', 'Nombre', 'Pais', 'contact', 'Email', 'Telefono']
		}
	},
	components: { ListTable }
}
</script>

<style scoped>
tr th:not(:first-child) {
	font-weight: 500;
	text-align: left;
	border-bottom: 1px solid black;
}
table tr:nth-child(even) {
	background: #f5f5f5;
}
td,
th {
	padding: 10px;
}
</style>
